import React from 'react';
import { useTranslation } from 'react-i18next';
import { GetSingleCase_case } from '../../../GraphQL';
import JobsItem from './JobsItem';
import Table from '@ssg/common/Components/Table';

interface Props {
	caseData: GetSingleCase_case;

}

const JobsTable: React.FC<Props> = ({ caseData }): React.ReactElement => {
	const { t } = useTranslation();

	return (
		<>
		<Table 
		data={caseData.jobs ?? []}
		keySelector={j => j.id}
		noDataFoundText="Ingen opgaver fundet"
		columns={[
		{
			label:'common.deadline',
			selectFn: j => j.deadline,
		},
		{
			label:'jobs.assignedTo',
			selectFn: j => j.assignedTo?.name ?? '',
		},
		{
			label:'common.description',
			selectFn: j => j.description,
			
		},
		]}
		/>
		</>
	 ); 
	}; 
export default JobsTable;
